<template>
    <b-modal
        v-model="modal.state"
        modal-class="general-modal"
        body-class="text-center"
        hide-footer
    >
        <template v-slot:modal-header-close>
            <b-button class="close-btn border-0">
                <i class="close-icon far fa-times" />
            </b-button>
        </template>

        <b-row class="mb-4">
            <b-col>
                <b-img
                    v-if="hasIllustration"
                    class="img illustration"
                    :src="img"
                    width="90"
                    height="75"
                />
                <b-img
                    v-else-if="user && user.avatar && user.avatar.publicStorageUrl"
                    class="avatar"
                    :src="user.avatar.publicStorageUrl"
                />
                <div
                    v-else-if="user"
                    class="avatar-wrapper"
                >
                    <div class="avatar alert-primary">
                        {{ `${user.firstName} ${user.lastName}` | initials(2) }}
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <h1 class="title">
                    {{ title }}
                </h1>
            </b-col>
        </b-row>

        <b-row
            class="mb-4"
            v-if="hasSubtitle"
        >
            <b-col class="d-flex">
                <p class="subtitle mx-auto mb-0">
                    {{ subtitle }}
                </p>
            </b-col>
        </b-row>

        <b-row
            v-if="hasAddressInput"
            class="mb-4 address-input-wrapper"
        >
            <b-col>
                <address-type-ahead
                    v-model="address"
                    class="input-group prepend-icon-input-group"
                    is-plain
                    allow-user-value
                    @input="$emit('addressInput')"
                    resource-type=""
                >
                    <template v-slot:before>
                        <b-input-group-prepend is-text>
                            <i
                                class="address-icon far fa-map-marker-alt text-gray-700"
                            />
                        </b-input-group-prepend>
                    </template>
                </address-type-ahead>
            </b-col>
        </b-row>

        <b-row
            class="mb-4"
        >
            <b-col>
                <b-button
                    class="action-button "
                    variant="primary"
                    @click="handleClick"
                    :disabled="isButtonDisabled"
                >
                    <p class="mb-0 text">
                        <b-spinner
                            small
                            v-if="loading"
                            class="mb-1"
                        />

                        {{ buttonText }}
                    </p>
                </b-button>
            </b-col>
        </b-row>

        <b-row class="mb-4">
            <b-col>
                <b-button
                    class="sign-in-btn"
                    :href="projects"
                    variant="outline-primary"
                    :disabled="loading"
                >
                    <p class="mb-0 text">
                        Existing Clients, Sign In
                    </p>
                </b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
    import './InterstitialModal.scss';
    import {INTERSTITIAL_MODAL_TYPES, SHOW_INTERSTITIAL_MODAL_EVENT} from "../../../../helpers/modals";
    import get from 'lodash/get';
    import {DEFAULT_AVATAR} from "../../../../helpers/images";
    import {myProjectsUrl} from "../../../helpers/externalRoutes";
    import AddressTypeAhead from "@milestoneslabs/milestones-ui-kit/src/components/AddressTypeAhead/AddressTypeAhead";
    import QueryStrings from "@milestoneslabs/milestones-unified-login/src/QueryStrings";

    export const INTERSTITIAL_MODAL_REDIRECT = 'interstitial-modal-redirect';

    export default {
        name: 'InterstitialModal',

        components: {
            AddressTypeAhead,
        },

        props: {
            loading: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                modal: {
                    state: false,
                },
                user: null,
                img: null,
                title: null,
                subtitle: null,
                buttonText: null,
                redirectLink: null,
                type: null,
                address: null,
            };
        },

        computed: {
            hasIllustration() {
                return Boolean(this.img);
            },

            hasSubtitle() {
                return this.type !== INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP;
            },

            hasAddressInput() {
                return this.type === INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP;
            },

            isButtonDisabled() {
                return this.loading || (this.type === INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP && !this.address);
            },

            avatar() {
                return get(this.user, 'avatar.publicStorageUrl') || DEFAULT_AVATAR;
            },

            projects() {
                return myProjectsUrl({
                    brandedLogin: window.brandedLogin,
                });
            }
        },

        methods: {
            handleShowInterstitialModalEvent({type, userInfo, img, title, subtitle, buttonText, redirectLink}) {
                this.reset();

                this.user = userInfo;
                this.img = img;
                this.title = title;
                this.subtitle = subtitle;
                this.buttonText = buttonText;
                this.redirectLink = redirectLink;
                this.type = type;

                this.modal.state = true;
            },

            handleClick() {
                if (this.type === INTERSTITIAL_MODAL_TYPES.HOME_OWNERSHIP) {
                    this.redirectLink += '&' + QueryStrings.HOH_ADDRESS + '=' + btoa(this.address);
                }

                this.$bus.$emit(INTERSTITIAL_MODAL_REDIRECT, this.redirectLink);
            },

            reset() {
                this.user = null;
                this.img = null;
                this.title = null;
                this.subtitle = null;
                this.buttonText = null;
                this.redirectLink = null;
                this.type = null;
                this.address = null;
            }
        },

        beforeMount() {
            this.$bus.$on(SHOW_INTERSTITIAL_MODAL_EVENT, this.handleShowInterstitialModalEvent);
        },

        beforeDestroy() {
            this.$bus.$off(SHOW_INTERSTITIAL_MODAL_EVENT, this.handleShowInterstitialModalEvent);
        },
    };
</script>
